import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';

@Injectable()
export class ApiAuthentInterceptor implements HttpInterceptor {

  readonly #authenticationService = inject(AuthenticationService);
  readonly #router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.#authenticationService.accessToken;
    const authorizationHeaders: HttpHeaders = req.headers.set('Authorization', 'Bearer ' + accessToken);
    const requestUpdate = this.#authenticationService.isAuthenticated ? {headers: authorizationHeaders} : {};

    const request = req.clone(requestUpdate);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => this.handleErrorRes(error))
    );
  }

  private handleErrorRes(error: HttpErrorResponse): Observable<never> {
    switch (error.status) {
      case 401:
        // Session expirée, token invalide ou session révoquée : on purge l'état
        // local et on renvoie au login, au lieu de laisser les écrans figés sur
        // leur loader (cf. dashboard opérateur). Le refresh de token reste un TODO.
        this.logoutToPublic();
        break;
      case 403:
        // Deux natures de 403 : le refus de Spring Security (token mort → corps
        // vide) et le refus MÉTIER (droits per-scénario `scenario.right.*`,
        // flags — corps ApiError avec title/code). Déconnecter sur un refus de
        // droit éjectait l'exploitant au moindre clic sur une action que
        // l'admin venait de lui retirer ; l'écran doit pouvoir afficher la
        // notification à la place.
        if (!this.isBusinessError(error)) {
          this.logoutToPublic();
        }
        break;
    }
    return throwError(() => error);
  }

  private isBusinessError(error: HttpErrorResponse): boolean {
    return !!(error.error && (error.error.title || error.error.code));
  }

  private logoutToPublic(): void {
    if (this.#authenticationService.isAuthenticated) {
      this.#authenticationService.logout();
      this.#router.navigate(['/public']);
    }
  }

}
